import { z } from 'zod';

import {
  PARTICIPANT_CODE_LENGTH,
  PARTICIPANT_CODE_PATTERN,
  normalizeParticipantCode,
} from '../lib/codeGenerator';

/**
 * 참여자 코드 입력(복원) 폼 스키마.
 *
 * 처리 흐름:
 * 1. `trim` 으로 앞뒤 공백 제거.
 * 2. 빈 문자열은 즉시 한국어 메시지로 거부.
 * 3. `normalizeParticipantCode` 로 대문자 변환 + 구분자 제거.
 * 4. 최종적으로 6자리 대문자 영숫자(0/1/I/O 제외) 정규식 검증.
 *
 * 사용자가 `K9R3-HM` 처럼 가독성을 위해 끊어 적어도, 또는 소문자로 입력해도
 * 자동으로 정상 형태(`K9R3HM`)로 변환되어 검증된다.
 */
export const participantCodeSchema = z.object({
  code: z
    .string()
    .trim()
    .min(1, '참여자 코드를 입력해 주세요.')
    .transform(normalizeParticipantCode)
    .pipe(
      z
        .string()
        .length(
          PARTICIPANT_CODE_LENGTH,
          `참여자 코드는 ${String(PARTICIPANT_CODE_LENGTH)}자리예요.`,
        )
        .regex(
          PARTICIPANT_CODE_PATTERN,
          '코드 형식이 올바르지 않아요. 영문 대문자/숫자 6자리(0·1·I·O 제외)를 입력해 주세요.',
        ),
    ),
});

/** 참여자 코드 입력 폼의 값 타입 — `code` 1개의 string 필드. */
export type ParticipantCodeFormValues = z.infer<typeof participantCodeSchema>;

/** UI에서 placeholder 등으로 노출하는 코드 예시. 의미 없는 무작위 6자리. */
export const PARTICIPANT_CODE_EXAMPLE = 'K9R3HM';
